import { ReactNode } from "react";
import Container from "src/components/layout/Container";
import tw from "src/utils/tw";

interface Props {
  bgColor?: string;
  className?: string;
  large?: boolean;
  children: ReactNode;
  full?: boolean;
}

function StepHeader(props: Props) {
  return (
    <div
      style={{
        backgroundColor: props.bgColor ? props.bgColor : undefined,
      }}
      className={tw(
        "fixed left-0 z-30 mb-4 min-h-[80px] w-full border-b border-borderGray pb-4 pt-4",
        !props.bgColor && "bg-bgGray",
        props.className
      )}
    >
      <Container large={props.large} full={props.full}>
        {props.children}
      </Container>
    </div>
  );
}

export default StepHeader;
